import { createEmitter } from "ts_utils";
import { AppUser } from "../../data/AppUser";
import { Services } from "../../services/Services";
import { ConfirmationBox } from "../../ui/ConfirmationBox";
import { UserManager } from "../UserManager";
import * as uih from "./UiHelper";
import { TimedMessageBox } from "../../ui/TimedMessageBox";

export class ManageAccountView {
	
	private _ui:HTMLDivElement;
	
	private _welcomeDiv:HTMLDivElement;
	
	private _deleteAccountLink:HTMLAnchorElement;
	private _closeBtn:HTMLButtonElement;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<ManageAccountViewEvent>();
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
		uih.hide(this._ui);
		
		this._welcomeDiv = this._ui.querySelector("#mav-welcome");
		this._deleteAccountLink = this._ui.querySelector(
			"#mav-deleteAccountLink");
		this._closeBtn = this._ui.querySelector("#mav-closeBtn");
	}
	
	public activate(user:AppUser):void {
		uih.show(this._ui);
		UserManager.get().hideLoadingOverlay();
		this._welcomeDiv.innerHTML = `Welcome, ${user.displayName}!`;
		this._enableUI();
	}
	
	public deactivate():void {
		uih.hide(this._ui);
		this._disableUI();
	}
	
	private _enableUI():void {
		this._closeBtn.disabled = false;
		this._addListeners();
	}
	
	private _disableUI():void {
		this._closeBtn.disabled = true;
		this._removeListeners();
	}
	
	private _onDeleteAccountLinkClick = async (e:MouseEvent):Promise<void> => {
		this._disableUI();
		let confirmationBox = new ConfirmationBox("Confirm that you want to " +
			"completely delete your account. This can not be undone.");
		let deleteAccount = await confirmationBox.awaitConfirmation();
		if (deleteAccount === true){
			let result = await Services.removeUser(UserManager.get().userId);
			if (result.success){
				window.location.reload();
				return;
			}
			else if (result.message === "hasTeams"){
				new TimedMessageBox("You must remove all teams from your " +
					"account before removing your user account", 4000, {});
			}
		}
		this._enableUI();
	}
	
	private _onCloseBtnClick = (e:MouseEvent):void => {
		this._emitter.emit(ManageAccountViewEvent.closeRequest);
	}
	
	private _addListeners():void {
		this._removeListeners();
		this._deleteAccountLink.addEventListener("click",
			this._onDeleteAccountLinkClick);
		this._closeBtn.addEventListener("click", this._onCloseBtnClick);
	}
	
	private _removeListeners():void {
		this._deleteAccountLink.removeEventListener("click",
			this._onDeleteAccountLinkClick);
		this._closeBtn.removeEventListener("click", this._onCloseBtnClick);
	}
}

export enum ManageAccountViewEvent {
	manageSubscriptionRequest,
	deleteAccountRequest,
	closeRequest
}